import React from 'react';
export function Footer() {
  return <footer className="w-full bg-black py-12 px-4 border-t border-gray-900 text-center" data-id="element-100">
      <div className="max-w-4xl mx-auto" data-id="element-101">
        <p className="text-gray-500 font-medium mb-4" data-id="element-102">
          © 2024 Electricista en Casa. Todos los derechos reservados.
        </p>
        <div className="flex justify-center gap-4 text-sm text-gray-400 mb-8 underline" data-id="element-103">
          <a href="#" className="hover:text-white transition-colors" data-id="element-104">
            Política de Privacidad
          </a>
          <span data-id="element-105">|</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-106">
            Términos y Condiciones
          </a>
          <span data-id="element-107">|</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-108">
            Contacto
          </a>
        </div>
        <p className="text-xs text-gray-600 leading-relaxed max-w-3xl mx-auto" data-id="element-109">
          Este producto es un libro digital educativo. No habilita para realizar
          instalaciones que requieran certificación oficial. Los resultados
          económicos mencionados son estimaciones basadas en el mercado real y
          pueden variar.
        </p>
      </div>
    </footer>;
}